import React, {useState, useEffect} from 'react';
import cn from '../lib/cn';

const YesNo = ({value, yesClasses = "", noClasses = ""}) => {
  return (
    <span className={cn(value ? yesClasses : noClasses)}>
      {value ? 'Yes' : 'No'}
    </span>
  );
}

export default YesNo;
